module.exports = __webpack_public_path__ + "img/result_download.687535ba.svg";